export const isRefunded = (status: string) => ['REFUND', 'CHARGEBACK'].includes(status)
